import { Button, GradientPageHeader, Icon, IconType } from '@lmc/ui-kit'
import Search from '@lmc/ui-kit/src/dataEntry/Input/components/Search/Search'
import type React from 'react'
import type { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'
import { commonPatterns } from '../../../../../../src/utils/enhancedTestIds'

type TeamListHeaderProps = {
  testId?: string
  openModal: () => void
  onSearch: Dispatch<SetStateAction<string>>
  title?: string
  searchPlaceholder?: string
  buttonTitle?: string
  buttonDisabled?: boolean
}

const StyledContainer = styled.div`
  max-width: 100%;
  margin-top: 24px;
  margin-bottom: 0px;
  margin-left: 24px;
  margin-right: 24px;
`

const StyledChild = styled.div`
  display: flex;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    flex-direction: column;
    margin-right: auto;
  }
`

const StyledSearch = styled(Search)`
  margin-right: 10px;
  width: 200px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin-bottom: 10px;
  }
`

const StyledMail = styled(Icon)`
  color: white;
`

const TeamListHeader: React.FC<TeamListHeaderProps> = ({
  testId,
  openModal,
  onSearch,
  title,
  searchPlaceholder,
  buttonTitle,
  buttonDisabled = false
}) => {
  // Generate test IDs using enhanced system
  const searchTestId = testId
    ? commonPatterns.input(testId, 'search')
    : undefined
  const inviteButtonTestId = testId
    ? commonPatterns.button(testId, 'invite')
    : undefined

  return (
    <StyledContainer data-testid={testId ? `${testId}-header` : undefined}>
      <GradientPageHeader title={title as string} gradient>
        <StyledChild>
          <StyledSearch
            placeholder={searchPlaceholder}
            onChange={(value) => onSearch(value?.target?.value)}
            data-testid={searchTestId}
          />
          <Button
            onClick={openModal}
            variant="primary"
            icon={<StyledMail customIcon={IconType.Mail} />}
            data-cy="btn-invite-team-member"
            data-testid={inviteButtonTestId}
            disabledByPermission={buttonDisabled}
          >
            {buttonTitle}
          </Button>
        </StyledChild>
      </GradientPageHeader>
    </StyledContainer>
  )
}

export default TeamListHeader
